import React, {Component} from "react";
import { Buffer } from "buffer";
import {Button, Card, Col, Form, Modal, Row, Typography} from "antd";
import Cookies from "universal-cookie";
import {sendIdealMessageService} from "../../../services/ideal/SendIdealMessageService";
import currencyFormat from "../../../helper/currencyFormat";

const {Text} = Typography;

class ConfirmCreditDoNetPo extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())

    constructor(props: any) {
        super(props);
        this.initState = {
            offerCode: "",
            ownerPhoneNumber: "",
            updateProcess: false,
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.promisedSetState({
            offerCode: this.props.offerCode,
            ownerPhoneNumber: this.props.ownerPhoneNumber,
        });
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.time !== prevProps.time) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                ownerPhoneNumber: this.props.ownerPhoneNumber,
            });
        }
    }

    onProcess = async () => {
        if (!this.state.ownerPhoneNumber) {
            Modal.error({
                title: 'Error',
                content: 'Nomor Telpon tidak valid'
            });
            return;
        }

        this.setState({
            updateProcess: true,
        });

        let phoneTarget = this.state.ownerPhoneNumber;
        phoneTarget = (phoneTarget.substring(0, 2) === "08") ? phoneTarget.replace(/^.{2}/g, '628') : phoneTarget;

        const dataSendToWhatsapp = {
            target: phoneTarget,
            template_name: "order_confirm_tunai_ver1_2",
            area: this.props.offerData?.area?.toUpperCase(),
            components: [{
                type: "body",
                parameters: [
                    {
                        type: "text",
                        text: this.props.offerData?.transaction_code
                    },
                    {
                        type: "text",
                        text: this.props.offerData?.vehicle?.variant_name
                    },
                    {
                        type: "text",
                        text: this.props.offerData?.vehicle?.color_name
                    },
                    {
                        type: "text",
                        text: currencyFormat(this.props.offerData?.price_and_bill?.otr)?.replace("Rp", "")
                    },
                    {
                        type: "text",
                        text: currencyFormat(this.props.offerData?.price_and_bill?.order_fee)?.replace("Rp", "")
                    },
                    {
                        type: "text",
                        text: this.props.offerData?.credit?.finco_code?.toUpperCase() +" "+ this.props.offerData?.credit?.finco_name?.toUpperCase()
                    },
                    {
                        type: "text",
                        text: this.props.offerData?.credit?.po_code?.toUpperCase()
                    },
                    {
                        type: "text",
                        text: currencyFormat(this.props.offerData?.credit?.dp_amount - ((this.props.offerData?.detail_promo?.length > 0) ? this.props.offerData?.detail_promo[0]?.discount : 0))?.replace("Rp", "")
                    },
                    {
                        type: "text",
                        text: currencyFormat(this.props.offerData?.credit?.installment_amount)?.replace("Rp", "")
                    },
                    {
                        type: "text",
                        text: this.props.offerData?.credit?.tenor
                    },
                    {
                        type: "text",
                        text: (this.props.offerData?.detail_promo?.length > 0) ? this.props.offerData?.detail_promo[0]?.code : "Tanpa Kode Promo"
                    },
                    {
                        type: "text",
                        text: (this.props.offerData?.detail_promo?.length > 0) ? currencyFormat(this.props.offerData?.detail_promo[0]?.discount)?.replace("Rp", "") : 0
                    },
                    {
                        type: "text",
                        text: currencyFormat(this.props.offerData?.price_and_bill?.total_bill)?.replace("Rp", "")
                    },
                    {
                        type: "text",
                        text: "virtual account"
                    },
                    {
                        type: "text",
                        text: this.props.offerData?.transaction_time?.substring(0, 10) + " 23:59"
                    },
                ]
            }]
        }

        try {
            await sendIdealMessageService.sendMessage(
                dataSendToWhatsapp
            ).then(async successData => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'Pesan dalam proses pengiriman'
                });
                this.props.onCloseProps("close");
                await this.promisedSetState({
                    updateProcess: false,
                });
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: ' ' + e
            });
            await this.promisedSetState({
                updateProcess: false,
            });
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <div>
                    <div style={{fontSize: "60%", color: "grey", textAlign: "right", marginBottom: 10}}>KodeTemplate: order_confirm_tunai_ver1_2</div>
                    <Form layout="vertical">
                        <Row style={{marginBottom: 7}}>
                            <Col xs={24} xl={10} className={`col-grey`}>Kode Offer:</Col>
                            <Col xs={24} xl={14}>{this.state.offerCode}</Col>
                        </Row>
                        <Row style={{marginBottom: 7}}>
                            <Col xs={24} xl={10} className={`col-grey`}>Nomor Telpon:</Col>
                            <Col xs={24} xl={14}>{this.state.ownerPhoneNumber}</Col>
                        </Row><br/>

                        <i>Isi Pesan Whatsapp:</i>
                        <Card>
                            <Text style={{fontSize: "90%", color: "gray"}}>
                                Konfirmasi untuk pemesanan secara KREDIT dengan nomor SPK {this.props.offerData?.transaction_code} tipe {this.props.offerData?.vehicle?.variant_name} dengan warna {this.props.offerData?.vehicle?.color_name} dengan harga OTR Rp {currencyFormat(this.props.offerData?.price_and_bill?.otr)?.replace("Rp", "")} dan biaya tambahan Rp {currencyFormat(this.props.offerData?.price_and_bill?.order_fee)?.replace("Rp", "")}.<br/><br/>
                                Pengajuan Kredit anda telah disetujui oleh {this.props.offerData?.credit?.finco_code?.toUpperCase()} - {this.props.offerData?.credit?.finco_name?.toUpperCase()} dengan nomor PO {this.props.offerData?.credit?.po_code?.toUpperCase()} dengan Uang Muka sebesar {currencyFormat(this.props.offerData?.credit?.dp_amount - ((this.props.offerData?.detail_promo?.length > 0) ? this.props.offerData?.detail_promo[0]?.discount : 0))?.replace("Rp", "")} dan cicilan sebesar {currencyFormat(this.props.offerData?.credit?.installment_amount)?.replace("Rp", "")} selama {this.props.offerData?.credit?.tenor} kali.<br/><br/>
                                Kode Promo yang diterapkan adalah {(this.props.offerData?.detail_promo?.length > 0) ? this.props.offerData?.detail_promo[0]?.code : "Tanpa Kode Promo"} dengan nilai potongan uang muka sebesar Rp {(this.props.offerData?.detail_promo?.length > 0) ? currencyFormat(this.props.offerData?.detail_promo[0]?.discount)?.replace("Rp", "") : 0}<br/><br/>
                                Total tagihan Uang Muka yang perlu dibayar adalah Rp {currencyFormat(this.props.offerData?.price_and_bill?.total_bill)?.replace("Rp", "")} melalui metode pembayaran "virtual account", kunjungi https://amartahonda.com/p/pembayaran untuk instruksi pembayaran lebih lengkap. Apabila tagihan belum dilunasi pada {this.props.offerData?.transaction_time?.substring(0, 10) + " 23:59"} maka pesanan akan dibatalkan secara otomatis.<br/><br/>
                                Kunjungi https://amartahonda.com/track untuk melacak pesanan anda.
                            </Text>
                        </Card><br/>

                        <Button type={"primary"} loading={this.state.updateProcess} onClick={() => this.onProcess()}> Kirim Konfirmasi Order Kredit DP PO NET</Button>
                    </Form>
                </div>
            </React.Fragment>
        );
    }
}

export default ConfirmCreditDoNetPo;
